import React from 'react';
import {FeedsContent} from "./FeedsContent";
import {trackWindowScroll} from "react-lazy-load-image-component";

export default React.memo(FeedsContent)